export enum CalComLayout {
	Monthly = 'month_view',
	Weekly = 'week_view',
	Column = 'column_view',
}